import React, { useState } from "react";
import { CircularProgress } from "@mui/material";
import { notification } from "antd";
import { useDispatch } from "react-redux";
import moment from "moment";

import { deleteShiftPlan } from "../../../../actions/v2/CalendarActions";
import { Strings } from "../../../../dataProvider/localize";
import v2Styles from "../../v2Styles.module.css";

export default function DeleteShiftPlan({ selectedPlan, onClose, onSubmitClose }) {

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const onDelete = () => {
    setLoading(true);
    dispatch(deleteShiftPlan(selectedPlan.id)).then(message => {
      setLoading(false);
      notification.success({
        message: Strings.success_title,
        description: message,
        className: "ant-success"
      })
      onSubmitClose(true);
    }).catch(err => {
      if (err) {
        setLoading(false);
        notification.error({
          message: Strings.error_title,
          description: err ? err : Strings.generic_error,
          className: "ant-error"
        })
      }
    })
  }

  return (
    <div className="v2-modal-container">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
              <div className={v2Styles.ModalHeading}>Delete Shift Plan - {moment(selectedPlan.applicable_period[0]).format("DD/MM")} - {moment(selectedPlan.applicable_end_date).format("DD/MM")} | {moment(selectedPlan.start_time).format("HH:mm A")} - {moment(selectedPlan.end_time).format("HH:mm A")}?</div>
            <div className="">
              <hr className="v3-modal-hr" />
            </div>
            <div className="" style={{ color: "#ff0000" }}>Are you sure you want to delete this shift plan? All shifts will be deleted for this plan.</div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 pt-3 text-right">
            <div style={{ display: "flex", alignItems: "center", justifyContent: "end", columnGap: "10px" }}>
              {loading ? (<CircularProgress size={20} />) : ''}
              <button type="button" className={`${v2Styles.OutlinedButton}`} onClick={() => onClose()} style={{ padding: "0px 5px" }}>Cancel</button>
              <button onClick={onDelete} disabled={loading} type="button" className={v2Styles.PrimaryButton}>Confirm</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}